import { useDispatch } from 'react-redux';
import '../../Common/css/app.css';
import '../../Common/css/main.css';
import '../../Common/css/common.css';
import '../../Common/css/payment.css';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../../Common/store.js';
import axios from 'axios';
import { LoadingModal, MessageModal } from '../../Merchant/components/modal/modal';
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown, faTimes } from "@fortawesome/free-solid-svg-icons";

function RowLabel({ label, value }) {
    return (
        <div style={{ display: "flex", alignItems: "center", padding: "4px 0", gap: "12px" }}>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#666", flexShrink: 0, width: "95px", minWidth: "95px", textAlign: "right" }}>{label}</span>
            <div style={{ flex: 1, minWidth: 0, display: "flex", justifyContent: "flex-start", textAlign: "left" }}>{value}</div>
        </div>
    );
}

const isDevUrl = typeof window !== 'undefined' && window.location.href.includes('dev');

function AppPaymentUI2({ hideHeader = false }) {
    let navigate = useNavigate();
    const location = useLocation();
    let dispatch = useDispatch();
    // /app 경로(앱)일 때는 /app/dashboard, /cp일 때는 /cp/dashboard, 그 외 /dashboard
    const getDashboardPath = () => {
        if (location.pathname.startsWith('/app')) return '/app/dashboard';
        if (location.pathname.startsWith('/cp')) return '/cp/dashboard';
        return '/dashboard';
    };
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [bank, setBank] = useState("");
    // const [memoModal, setMemoModal] = useState(false);
    // const [memoTab, setMemoTab] = useState("list");
    const [approvalStatus, setApprovalStatus] = useState(null); // null, "requesting", "complete"
    const [paymentSuccessModal, setPaymentSuccessModal] = useState({ visible: false, pharmacyName: "", amount: 0 });
    const [toast, setToast] = useState({ visible: false, message: "", type: "success" }); // type: 'success' | 'error'
    // const [deleteMemoModal, setDeleteMemoModal] = useState({ open: false, memoIndex: null });

    // // 업체별 메모를 불러오는 함수
    // const getMemosForPharmacy = (pharmacyCode) => {
    //     if (!pharmacyCode) return [];
    //     const saved = localStorage.getItem(`paymentMemos_${pharmacyCode}`);
    //     return saved ? JSON.parse(saved) : [];
    // };

    // const [memos, setMemos] = useState([]);

    // // 메모 추가: 제목 없이 내용만 사용
    // const [memoForm, setMemoForm] = useState({
    //     content: ""
    // });

    const [isSubmitting, setIsSubmitting] = useState(false);
    // 헤더 토글: 두 가지 UI 전환 (A | B)
    const [uiMode, setUiMode] = useState('A');
    // 생년월일(개인) / 사업자등록번호(사업자) 토글
    const [idType, setIdType] = useState('personal');

    // localStorage에서 이전 약국 정보 불러오기 (새로고침 시 유지)
    const getSavedPharmacyName = () => {
        const saved = localStorage.getItem("currentSelectedPharmacyForPayment");
        if (saved) {
            try {
                const pharmacy = JSON.parse(saved);
                return pharmacy.name && pharmacy.code ? `${pharmacy.name}(${pharmacy.code})` : pharmacy.name || "";
            } catch (e) {
                return "";
            }
        }
        return "";
    };

    const getSavedPharmacyCode = () => {
        const saved = localStorage.getItem("currentSelectedPharmacyForPayment");
        if (saved) {
            try {
                const pharmacy = JSON.parse(saved);
                return pharmacy.code || "";
            } catch (e) {
                return "";
            }
        }
        return "";
    };

    // 업체명만 표시 (코드 제외) — "이름(코드)" → "이름"
    const getDisplayCompanyName = () => {
        const full = formData.CompanyName || "";
        const m = full.match(/^(.+?)\((.+?)\)$/);
        return m ? m[1].trim() : full;
    };

    // 현재 선택 약국의 추가 정보 (약국코드, 연락처, 주소) — localStorage 기준
    const getCurrentPharmacyExtra = () => {
        const saved = localStorage.getItem("currentSelectedPharmacyForPayment");
        if (!saved) return null;
        try {
            const p = JSON.parse(saved);
            return {
                code: p.code || "-",
                phone: p.phone || "-",
                address: p.address || "-",
            };
        } catch (e) {
            return null;
        }
    };

    const [formData, setFormData] = useState({
        Amt: "",
        BuyerName: "",
        BuyerHpTel: "",
        card_num: "",
        CardPw: "", // 비밀번호 앞 2자리 (미사용 - 주석처리)
        CardCvv: "",
        ExpMonth: "",
        ExpYear: "",
        BirthDateOrIDNo: "", // 생년월일/사업자등록번호 (미사용 - 주석처리)
        MerchantName: "상품결제", // 가맹점명 (기본값: 상품결제)
        CompanyName: "",
        CompanyCode: "",
        CardQuota: "00",
        CardCompany: "", // 카드사 (신한, 삼성, 하나 등)
    });

    const [displayAmt, setDisplayAmt] = useState("");
    const [cardNumDisplay, setCardNumDisplay] = useState(""); // 표시용 (하이픈 포함)

    useEffect(() => {
        dispatch(change_Current_Location("수기결제"));
        dispatch(changeHeaderTitle({
            mainTitle: "수기결제",
            subTitle: "",
        }));

        // 거래처명, 거래처코드는 사용자가 직접 입력하도록 변경 (디폴트 값 없음)

        // // 현재 선택된 업체의 메모 불러오기
        // const currentPharmacyCode = formData.CompanyCode ||
        //     (localStorage.getItem("currentSelectedPharmacyForPayment") ?
        //         JSON.parse(localStorage.getItem("currentSelectedPharmacyForPayment")).code : "");
        // if (currentPharmacyCode) {
        //     setMemos(getMemosForPharmacy(currentPharmacyCode));
        // } else {
        //     setMemos([]);
        // }
    }, [dispatch]);

    // // 업체가 변경될 때마다 메모 다시 불러오기
    // useEffect(() => {
    //     if (formData.CompanyCode) {
    //         setMemos(getMemosForPharmacy(formData.CompanyCode));
    //     } else {
    //         setMemos([]);
    //     }
    // }, [formData.CompanyCode]);

    const handleAmtChange = (e) => {
        let val = e.target.value;
        let numeric = val.replace(/\D/g, "");
        numeric = numeric.slice(0, 9);

        setFormData((prev) => ({
            ...prev,
            Amt: numeric,
        }));

        if (!numeric) {
            setDisplayAmt("");
        } else {
            setDisplayAmt(parseInt(numeric, 10).toLocaleString("ko-KR"));
        }
    };

    const handleCardInput = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 16); // 최대 16자리

        // 숫자만 formData에 저장
        setFormData((prev) => ({
            ...prev,
            card_num: val,
        }));

        // 표시용: 4자리마다 공백 추가
        let displayVal = val.replace(/(\d{4})(?=\d)/g, '$1 ');
        setCardNumDisplay(displayVal);

        setBank("");

        // 16자리 입력 완료 시 유효기간(월) 필드로 포커스 이동
        if (val.length === 16) {
            setTimeout(() => {
                const monthInput = document.querySelector('input[name="ExpMonth"]');
                if (monthInput) {
                    monthInput.focus();
                }
            }, 0);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // 필수 필드 확인 함수
    const isFormValid = () => {
        const checkField = (value) => {
            if (value === null || value === undefined) return false;
            const strValue = typeof value === 'string' ? value.trim() : String(value).trim();
            return strValue !== "";
        };

        // 필수 필드: 카드번호, 결제금액, 유효기간(월/년), 거래처명
        // 선택 필드: 생년월일/사업자번호, 비밀번호, 거래처코드
        return (
            checkField(formData.card_num) &&
            checkField(formData.Amt) &&
            checkField(formData.ExpMonth) &&
            checkField(formData.ExpYear) &&
            checkField(formData.CompanyName)
        );
    };

    const onSubmitSugi = async () => {
        if (isSubmitting || !isFormValid()) return;
        setIsSubmitting(true);
        setApprovalStatus("requesting");

        const baseUrl = process.env.REACT_APP_API || "";
        const amountNum = Number(String(formData.Amt).replace(/,/g, "")) || 0;
        const mchtTrdNo = `cp_direct_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;

        // 수기 직입 결제용 약국 정보 (거래처코드는 고정값)
        const pharmacyName = (formData.CompanyName || "").trim();
        const pharmacyCode = "0000";
        const pharmacyNameForApi = pharmacyName || "";

        try {
            const { data } = await axios.post(
                baseUrl + "/api/cp/payment/manual/direct",
                {
                    // 1) 약국 정보 (직접 입력)
                    pharmacyName,
                    pharmacyCode,

                    // 2) 거래/결제 정보
                    mchtTrdNo,
                    trdAmt: amountNum,
                    instmtMon: formData.CardQuota || "00", // 일시불 = "00"
                    pmtprdNm: "상품결제",

                    // 3) 고객 정보 (현재는 약국 정보를 그대로 사용)
                    mchtCustNm: pharmacyNameForApi,
                    mchtCustId: "0000",

                    // 4) 카드 정보
                    cardNo: formData.card_num.replace(/\s/g, ""),
                    vldDtMon: String(formData.ExpMonth).padStart(2, "0"),
                    vldDtYear: String(formData.ExpYear).slice(-2),

                    // 5) (구인증 모드용) 식별값 / 비밀번호 앞 2자리
                    idntNo: String(formData.BirthDateOrIDNo || "").trim(),
                    cardPwd: String(formData.CardPw || "").trim(),

                    // 5-1) 영업자명
                    salespersonName: String(formData.BuyerName || "").trim(),

                    // 6) 선택값 (필요 시 확장 가능)
                    // mobileYn / osType / email 등은 현재 화면에서 별도 입력 필드가 없어 기본값만 사용
                    mobileYn: "Y",
                    osType: "M",
                },
                { withCredentials: true }
            );

            // code 1000이어도 data.data.status가 'completed'일 때만 성공 처리
            const paymentStatus = data?.data?.status;
            const isPaymentCompleted = paymentStatus === "COMPLETED";

            if (data?.code === 1000 && isPaymentCompleted) {
                if (formData.CompanyName && formData.CompanyCode) {
                    const match = formData.CompanyName.match(/^(.+?)\((.+?)\)$/);
                    if (match) {
                        const pharmacyName = match[1];
                        const pharmacyCode = match[2];
                        const saved = localStorage.getItem("paidPharmacies");
                        let paidPharmaciesList = saved ? (() => { try { return JSON.parse(saved); } catch (e) { return []; } })() : [];
                        if (!paidPharmaciesList.some(p => p.name === pharmacyName && p.code === pharmacyCode)) {
                            paidPharmaciesList.push({ name: pharmacyName, code: pharmacyCode, paidAt: new Date().toISOString() });
                            localStorage.setItem("paidPharmacies", JSON.stringify(paidPharmaciesList));
                        }
                    }
                }
                setFormData({
                    Amt: "",
                    BuyerName: "",
                    BuyerHpTel: "",
                    card_num: "",
                    CardPw: "",
                    CardCvv: "",
                    ExpMonth: "",
                    ExpYear: "",
                    BirthDateOrIDNo: "",
                    MerchantName: "상품결제",
                    CompanyName: "",
                    CompanyCode: "",
                    CardQuota: "00",
                });
                setBank("");
                setDisplayAmt("");
                setCardNumDisplay("");
                setApprovalStatus(null);
                setIsSubmitting(false);
                setPaymentSuccessModal({
                    visible: true,
                    pharmacyName: pharmacyNameForApi || "",
                    amount: amountNum,
                });
                return;
            }
            setApprovalStatus(null);
            setIsSubmitting(false);
            const failMsg = data?.data?.outRsltMsg ?? data?.data?.provider_result?.outRsltMsg ?? data?.msg ?? "결제에 실패했습니다.";
            setToast({ visible: true, message: failMsg, type: "error" });
            setTimeout(() => setToast(prev => ({ ...prev, visible: false })), 2000);
        } catch (err) {
            setApprovalStatus(null);
            setIsSubmitting(false);
            const res = err?.response?.data;
            const msg = res?.data?.outRsltMsg ?? res?.data?.provider_result?.outRsltMsg ?? res?.msg ?? "결제 요청 중 오류가 발생했습니다.";
            setToast({ visible: true, message: msg, type: "error" });
            setTimeout(() => setToast(prev => ({ ...prev, visible: false })), 2000);
        }
    };

    const inputStyle = {
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid #f0f0f0",
        fontSize: "14px",
        backgroundColor: "transparent",
        outline: "none",
        fontWeight: 600,
        width: "100%",
        textAlign: "left",
    };

    return (
        <div style={{
            ...(hideHeader ? { flex: 1, minHeight: 0 } : { minHeight: "100dvh" }),
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: "768px",
            margin: "0 auto",
            background: "#FFFFFF",
            overflowX: "hidden",
            boxSizing: "border-box",
        }}>
            <style>
                {`
                    button, a, [onClick] {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        -webkit-touch-callout: none;
                        user-select: none;
                        transition: transform 0.1s ease, opacity 0.1s ease;
                    }
                    button:focus, a:focus, [onClick]:focus {
                        outline: none !important;
                    }
                    button:active, a:active, [onClick]:active {
                        outline: none !important;
                        transform: scale(0.96);
                        opacity: 0.8;
                    }
                    input:focus, select:focus, textarea:focus {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        border-color: #f0f0f0 !important;
                        box-shadow: none !important;
                    }
                    input, select, textarea {
                        outline: none !important;
                    }
                    input:focus-visible {
                        outline: none !important;
                        border-color: #f0f0f0 !important;
                        box-shadow: none !important;
                    }
                    select {
                        appearance: none !important;
                        -webkit-appearance: none !important;
                        -moz-appearance: none !important;
                        background-image: none !important;
                    }
                    select::-ms-expand {
                        display: none !important;
                    }
                `}
            </style>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            {/* 승인 모달 */}
            {approvalStatus && (
                <>
                    <style>
                        {`
                            @keyframes approvalPulse {
                                0%, 100% {
                                    opacity: 1;
                                    transform: scale(1);
                                }
                                50% {
                                    opacity: 0.5;
                                    transform: scale(0.8);
                                }
                            }
                            /* 카드번호, 유효기간, 결제금액 placeholder - 숫자이므로 20px */
                            input[name="card_num"]::placeholder,
                            input[name="ExpMonth"]::placeholder,
                            input[name="ExpYear"]::placeholder,
                            input[name="Amt"]::placeholder {
                                font-size: 20px;
                            }
                            /* 할부, 업체명 placeholder - 문자이므로 18px */
                            select[name="CardQuota"] option,
                            input[name="CompanyName"]::placeholder {
                                font-size: 18px;
                            }
                        `}
                    </style>
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 2000,
                            padding: "20px",
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "20px",
                                width: "100%",
                                maxWidth: "320px",
                                padding: "32px 24px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "20px",
                                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
                            }}
                        >
                            {approvalStatus === "requesting" ? (
                                <>
                                    <div style={{
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "#111827",
                                        textAlign: "center",
                                    }}>
                                        승인요청중
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        gap: "8px",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <div style={{
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#3182F6",
                                            animation: "approvalPulse 1.4s ease-in-out infinite",
                                        }}></div>
                                        <div style={{
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#9CA3AF",
                                            animation: "approvalPulse 1.4s ease-in-out infinite 0.2s",
                                        }}></div>
                                        <div style={{
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#9CA3AF",
                                            animation: "approvalPulse 1.4s ease-in-out infinite 0.4s",
                                        }}></div>
                                    </div>
                                </>
                            ) : approvalStatus === "complete" ? (
                                <>
                                    <div style={{
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "#111827",
                                        textAlign: "center",
                                    }}>
                                        승인완료
                                    </div>
                                    <div style={{
                                        width: "52px",
                                        height: "52px",
                                        borderRadius: "50%",
                                        backgroundColor: "#22C55E",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <FontAwesomeIcon icon={faCheck} style={{ fontSize: "32px", color: "#fff" }} />
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                </>
            )}

            {/* 결제 성공 모달: 누구에게 얼마 결제 성공 → 확인 시 대시보드 */}
            {paymentSuccessModal.visible && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 2000,
                        padding: "24px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "320px",
                            background: "#FFFFFF",
                            borderRadius: "16px",
                            padding: "24px",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                        }}
                    >
                        <div style={{ fontSize: "18px", fontWeight: 600, color: "#111827", textAlign: "center", marginBottom: "20px" }}>
                            결제성공했습니다.
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "12px",
                                padding: "12px 16px",
                                background: "#F9FAFB",
                                borderRadius: "12px",
                                marginBottom: "20px",
                            }}
                        >
                            <span style={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}>
                                {paymentSuccessModal.pharmacyName}
                            </span>
                            <span style={{ fontSize: "15px", fontWeight: 600, color: "#3182F6" }}>
                                {Number(paymentSuccessModal.amount).toLocaleString()}원
                            </span>
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                // 모달 닫기
                                setPaymentSuccessModal({ visible: false, pharmacyName: "", amount: 0 });

                                // 새창(window.open)으로 띄워진 경우에는 창을 닫고,
                                // 그렇지 않으면 기존 동작대로 대시보드로 이동
                                try {
                                    if (window.opener && !window.opener.closed) {
                                        window.close();
                                        return;
                                    }
                                } catch (e) {
                                    // window.opener 접근이 막혀도 앱 동작에는 영향 없음
                                }

                                navigate(getDashboardPath());
                            }}
                            style={{
                                width: "100%",
                                padding: "14px",
                                background: "#3182F6",
                                color: "#fff",
                                border: "none",
                                borderRadius: "12px",
                                fontSize: "16px",
                                fontWeight: 600,
                                cursor: "pointer",
                            }}
                        >
                            확인
                        </button>
                    </div>
                </div>
            )}

            {!hideHeader && (
            <div style={{
                background: "linear-gradient(160deg, #0b3a6f 0%, #0d2b53 60%, #08223f 100%)",
                height: "62px",
                padding: "0 12px 0 10px",
                color: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                boxSizing: "border-box"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 2px",
                    position: "relative",
                    width: "100%",
                }}>
                    <button
                        onClick={() => navigate(getDashboardPath())}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "2px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <ChevronLeft size={28} color="#FFFFFF" />
                    </button>
                    <h1 style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontSize: "16px",
                        fontWeight: 700,
                        color: "#FFFFFF",
                        margin: 0,
                    }}>
                        수기결제
                    </h1>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0,
                        background: "rgba(255,255,255,0.2)",
                        borderRadius: "8px",
                        padding: "2px",
                        minWidth: "72px",
                    }}>
                        <button
                            type="button"
                            onClick={() => setUiMode('A')}
                            style={{
                                padding: "4px 10px",
                                fontSize: "12px",
                                fontWeight: 600,
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                background: uiMode === 'A' ? "#FFFFFF" : "transparent",
                                color: uiMode === 'A' ? "#0d2b53" : "rgba(255,255,255,0.9)",
                            }}
                        >
                            A
                        </button>
                        <button
                            type="button"
                            onClick={() => setUiMode('B')}
                            style={{
                                padding: "4px 10px",
                                fontSize: "12px",
                                fontWeight: 600,
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                background: uiMode === 'B' ? "#FFFFFF" : "transparent",
                                color: uiMode === 'B' ? "#0d2b53" : "rgba(255,255,255,0.9)",
                            }}
                        >
                            B
                        </button>
                    </div>
                </div>
            </div>
            )}

            {/* 메인: 스크롤 영역 + 하단 고정 결제 버튼 */}
            <div style={{
                flex: 1,
                minHeight: 0,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
            }}>
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflowY: "auto",
                    overflowX: "hidden",
                    WebkitOverflowScrolling: "touch",
                    touchAction: "pan-y",
                    padding: "0 16px calc(100px + env(safe-area-inset-bottom, 0px)) 16px",
                    boxSizing: "border-box",
                }}>
                {uiMode === 'A' && (
                <div style={{ padding: "18px 0 0px" }}>
                    {/* 업체정보 - 한 줄에 하나씩 */}
                    <div style={{
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        padding: "16px",
                        marginBottom: "16px",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                    }}>
                        <div style={{ fontSize: "18px", fontWeight: 700, color: "#191f28", marginBottom: "4px" }}>업체정보</div>
                        <RowLabel label="상품명" value={<input name="MerchantName" type="text" placeholder="상품명" value={formData.MerchantName} onChange={(e) => setFormData(prev => ({ ...prev, MerchantName: e.target.value }))} style={inputStyle} />} />
                        <RowLabel label="영업담당" value={<input name="BuyerName" type="text" placeholder="영업담당자 입력" value={formData.BuyerName} onChange={(e) => setFormData(prev => ({ ...prev, BuyerName: e.target.value }))} style={inputStyle} />} />
                        <RowLabel label="거래처" value={<input name="CompanyName" type="text" placeholder="거래처명 입력" value={formData.CompanyName} onChange={(e) => setFormData(prev => ({ ...prev, CompanyName: e.target.value }))} style={inputStyle} />} />
                        {/* <RowLabel label="거래처 코드" value={<input name="CompanyCode" type="text" placeholder="거래처 코드" value={formData.CompanyCode} onChange={(e) => setFormData(prev => ({ ...prev, CompanyCode: e.target.value }))} style={inputStyle} />} /> */}
                    </div>

                    {/* 결제정보 - 한 줄에 하나씩 */}
                    <div style={{
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        padding: "16px",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                    }}>
                        <div style={{ fontSize: "18px", fontWeight: 700, color: "#191f28", marginBottom: "4px" }}>결제정보</div>
                        {/* 카드사 주석처리 */}
                        {/* <RowLabel label="카드사" value={
                            <div style={{ position: "relative", flex: 1, minWidth: 0 }}>
                                <select name="CardCompany" value={formData.CardCompany} onChange={(e) => setFormData(prev => ({ ...prev, CardCompany: e.target.value }))} style={{ ...inputStyle, width: "100%", paddingRight: "28px", appearance: "none", WebkitAppearance: "none", MozAppearance: "none", cursor: "pointer" }}>
                                    <option value="">카드사 선택</option>
                                    <option value="신한">신한</option>
                                    <option value="삼성">삼성</option>
                                    <option value="하나">하나</option>
                                    <option value="현대">현대</option>
                                    <option value="KB">KB</option>
                                    <option value="우리">우리</option>
                                    <option value="NH">NH</option>
                                    <option value="씨티">씨티</option>
                                    <option value="롯데">롯데</option>
                                    <option value="기타">기타</option>
                                </select>
                                <div style={{ position: "absolute", right: "4px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}><FontAwesomeIcon icon={faChevronDown} style={{ fontSize: "16px", color: "#6B7280" }} /></div>
                            </div>
                        } /> */}
                        <RowLabel label="결제금액" value={<input name="Amt" type="text" inputMode="numeric" placeholder="금액 입력" value={displayAmt} onChange={handleAmtChange} style={inputStyle} />} />
                        <RowLabel label="카드번호" value={<input name="card_num" type="text" inputMode="numeric" placeholder="카드번호" value={cardNumDisplay} onChange={handleCardInput} style={{ ...inputStyle, fontVariantNumeric: "tabular-nums" }} />} />
                        {bank && <div style={{ marginTop: "-8px", marginBottom: "4px", fontSize: "12px", color: "#EF4444", fontWeight: 500 }}>* {bank}</div>}
                        <RowLabel label="유효기간" value={
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "6px", flex: 1, minWidth: 0, borderBottom: "1px solid #f0f0f0" }}>
                                <input name="ExpMonth" type="text" inputMode="numeric" maxLength={2} placeholder="월" value={formData.ExpMonth} onChange={(e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 2); setFormData(prev => ({ ...prev, ExpMonth: v })); if (v.length === 2) document.querySelector('input[name="ExpYear"]')?.focus(); }} style={{ ...inputStyle, width: "48px", borderBottom: "none", textAlign: "left" }} />
                                <span style={{ color: "#6B7280", fontWeight: 500 }}>/</span>
                                <input name="ExpYear" type="text" inputMode="numeric" maxLength={2} placeholder="년" value={formData.ExpYear} onChange={(e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 2); setFormData(prev => ({ ...prev, ExpYear: v })); if (v.length === 2 && isDevUrl) document.querySelector('input[name=\"BirthDateOrIDNo\"]')?.focus(); }} style={{ ...inputStyle, width: "48px", borderBottom: "none", textAlign: "left" }} />
                            </div>
                        } />
                        <RowLabel label="할부개월" value={
                            <div style={{ position: "relative", flex: 1, minWidth: 0 }}>
                                <select name="CardQuota" value={formData.CardQuota} onChange={handleChange} style={{ ...inputStyle, width: "100%", paddingRight: "28px", appearance: "none", WebkitAppearance: "none", MozAppearance: "none", cursor: "pointer" }}>
                                    <option value="00">일시불</option>
                                    <option value="01">01개월</option>
                                    <option value="02">02개월</option>
                                    <option value="03">03개월</option>
                                    <option value="04">04개월</option>
                                    <option value="05">05개월</option>
                                    <option value="06">06개월</option>
                                    <option value="07">07개월</option>
                                    <option value="08">08개월</option>
                                    <option value="09">09개월</option>
                                    <option value="10">10개월</option>
                                </select>
                                <div style={{ position: "absolute", right: "4px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}><FontAwesomeIcon icon={faChevronDown} style={{ fontSize: "16px", color: "#6B7280" }} /></div>
                            </div>
                        } />
                        {/* dev URL일 때만 생년월일/사업자등록번호·비밀번호 표시 */}
                        {isDevUrl && (
                        <>
                        <RowLabel
                            label={idType === 'personal' ? '생년월일' : '사업자등록번호'}
                            value={
                                <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: 0 }}>
                                    <input
                                        name="BirthDateOrIDNo"
                                        type="text"
                                        inputMode="numeric"
                                        placeholder={idType === 'personal' ? '생년월일 6자리' : '사업자등록번호 10자리'}
                                        value={formData.BirthDateOrIDNo}
                                        onChange={(e) => setFormData(prev => ({ ...prev, BirthDateOrIDNo: e.target.value.replace(/\D/g, "").slice(0, idType === 'personal' ? 6 : 10) }))}
                                        style={{ ...inputStyle, flex: 1, minWidth: 0, fontVariantNumeric: "tabular-nums" }}
                                    />
                                    <div style={{ display: "flex", flexShrink: 0, background: "#f2f4f6", borderRadius: "8px", padding: "2px" }}>
                                        <button type="button" onClick={() => setIdType('personal')} style={{ padding: "4px 10px", fontSize: "12px", fontWeight: 600, border: "none", borderRadius: "6px", cursor: "pointer", background: idType === 'personal' ? "#fff" : "transparent", color: idType === 'personal' ? "#191f28" : "#8b95a1", boxShadow: idType === 'personal' ? "0 1px 2px rgba(0,0,0,0.06)" : "none" }}>개인</button>
                                        <button type="button" onClick={() => setIdType('business')} style={{ padding: "4px 10px", fontSize: "12px", fontWeight: 600, border: "none", borderRadius: "6px", cursor: "pointer", background: idType === 'business' ? "#fff" : "transparent", color: idType === 'business' ? "#191f28" : "#8b95a1", boxShadow: idType === 'business' ? "0 1px 2px rgba(0,0,0,0.06)" : "none" }}>사업자</button>
                                    </div>
                                </div>
                            }
                        />
                        <RowLabel label="비밀번호" value={<div style={{ display: "flex", alignItems: "center", gap: "8px" }}><input name="cardPin2" type="text" inputMode="numeric" maxLength={2} placeholder="" value={formData.CardPw} onChange={(e) => setFormData(prev => ({ ...prev, CardPw: e.target.value.replace(/\D/g, "").slice(0, 2) }))} readOnly onFocus={(e) => e.target.removeAttribute('readonly')} style={{ ...inputStyle, width: "48px", letterSpacing: "4px", fontVariantNumeric: "tabular-nums", WebkitTextSecurity: "disc" }} autoComplete="off" /><span style={{ fontSize: "14px", fontWeight: 600, color: "#8b95a1", letterSpacing: "2px" }}>**</span></div>} />
                        </>
                        )}
                    </div>
                </div>
                )}
                {uiMode === 'B' && (
                <div style={{
                    padding: "18px 10px 16px",
                    minHeight: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#8b95a1",
                    fontSize: "14px",
                }}>
                    UI B — 여기에 두 번째 UI를 구성하세요.
                </div>
                )}
                </div>
                {/* 결제하기 버튼 - 하단 고정 (UI A일 때만, position: fixed로 항상 노출) */}
                {uiMode === 'A' && (
                <div style={{
                    position: "fixed",
                    bottom: 35,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "100%",
                    maxWidth: "768px",
                    padding: "12px 16px calc(10px + env(safe-area-inset-bottom, 0px))",
                    backgroundColor: "#FFFFFF",
                    boxSizing: "border-box",
                    zIndex: 50,
                }}>
                <button
                    type="button"
                    onClick={onSubmitSugi}
                    disabled={isSubmitting || !isFormValid()}
                    style={{
                        width: "100%",
                        padding: "16px",
                        backgroundColor: (!isFormValid() || isSubmitting) ? "#CBD5E1" : "#3182F6",
                        color: "#fff",
                        border: "none",
                        borderRadius: "16px",
                        fontSize: "16px",
                        fontWeight: 700,
                        cursor: (!isFormValid() || isSubmitting) ? "not-allowed" : "pointer",
                        boxShadow: (!isFormValid() || isSubmitting) ? "none" : "0 4px 12px rgba(49, 130, 246, 0.3)",
                    }}
                >
{isSubmitting ? "요청중..." : "결제하기"}
                    </button>
                </div>
                )}
            </div>


            {/* 메모장 모달 - 사용 안 함 */}
            {/* {memoModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                        padding: "20px",
                    }}
                    onClick={() => {
                        setMemoModal(false);
                        setMemoForm({ content: "" });
                        setMemoTab("new");
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "20px",
                            width: "100%",
                            maxWidth: "400px",
                            padding: "0",
                            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
                            overflow: "hidden",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "16px 20px",
                            borderBottom: "1px solid #F3F4F6",
                        }}>
                            <h2 style={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#111827",
                                margin: 0,
                            }}>
                                메모 추가
                            </h2>
                        </div>

                        {memoTab === "new" && (
                            <div style={{ display: "flex", flexDirection: "column", padding: "16px 20px" }}>
                                <textarea
                                    placeholder="메모 내용을 입력하세요"
                                    value={memoForm.content}
                                    onChange={(e) => setMemoForm({ ...memoForm, content: e.target.value })}
                                    style={{
                                        width: "100%",
                                        minHeight: "100px",
                                        padding: "10px 12px",
                                        border: "1px solid #D1D5DB",
                                        borderRadius: "8px",
                                        fontSize: "18px",
                                        resize: "vertical",
                                        fontFamily: "inherit",
                                        outline: "none",
                                        fontVariantNumeric: "tabular-nums",
                                    }}
                                />
                                <div style={{
                                    display: "flex",
                                    gap: "8px",
                                    marginTop: "16px",
                                }}>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setMemoModal(false);
                                            setMemoForm({ content: "" });
                                            setMemoTab("new");
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: "12px",
                                            backgroundColor: "#E5E7EB",
                                            color: "#111827",
                                            border: "none",
                                            borderRadius: "8px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                        }}
                                    >
                                        닫기
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (memoForm.content.trim()) {
                                                if (!formData.CompanyCode) {
                                                    setToast({ visible: true, message: "업체를 먼저 선택해주세요." });
                                                    setTimeout(() => {
                                                        setToast(prev => ({ ...prev, visible: false }));
                                                    }, 2000);
                                                    return;
                                                }
                                                const newMemo = {
                                                    content: memoForm.content.trim(),
                                                    createdAt: new Date().toISOString(),
                                                };
                                                const updatedMemos = [...memos, newMemo];
                                                setMemos(updatedMemos);
                                                localStorage.setItem(`paymentMemos_${formData.CompanyCode}`, JSON.stringify(updatedMemos));
                                                setMemoForm({ content: "" });
                                                setMemoModal(false);
                                                setTimeout(() => {
                                                    setToast({ visible: true, message: "메모가 저장되었습니다." });
                                                    setTimeout(() => {
                                                        setToast(prev => ({ ...prev, visible: false }));
                                                    }, 2000);
                                                }, 100);
                                            } else {
                                                setToast({ visible: true, message: "메모 내용을 입력해주세요." });
                                                setTimeout(() => {
                                                    setToast(prev => ({ ...prev, visible: false }));
                                                }, 2000);
                                            }
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: "12px",
                                            backgroundColor: "#3182F6",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "8px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                        }}
                                    >
                                        추가
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )} */}

            {/* 토스트 알람 애니메이션 스타일 */}
            <style>
                {`
                    @keyframes slideDownToast {
                        from {
                            opacity: 0;
                            transform: translateX(-50%) translateY(-100%);
                        }
                        to {
                            opacity: 1;
                            transform: translateX(-50%) translateY(0);
                        }
                    }
                `}
            </style>

            {/* 토스트 알람 */}
            {toast.visible && (
                <div
                    style={{
                        position: "fixed",
                        top: "10px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100%",
                        maxWidth: "768px",
                        padding: "0 16px",
                        boxSizing: "border-box",
                        zIndex: 3000,
                        display: "flex",
                        justifyContent: "center",
                        animation: "slideDownToast 0.3s ease-out",
                        pointerEvents: "none", // 클릭 이벤트를 통과시켜 뒤로가기 버튼 클릭 가능하게
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            padding: "12px 16px",
                            borderRadius: "12px",
                            backgroundColor: "#FFFFFF",
                            color: "#111827",
                            fontSize: "14px",
                            fontWeight: 500,
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                            pointerEvents: "auto", // 토스트 메시지 자체는 클릭 가능하게
                        }}
                    >
                        {/* 성공: 파란 원 + 체크, 실패: 빨간 원 + X */}
                        <div
                            style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                backgroundColor: toast.type === "error" ? "#F04452" : "#3182F6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <FontAwesomeIcon
                                icon={toast.type === "error" ? faTimes : faCheck}
                                style={{ fontSize: "14px", color: "#FFFFFF" }}
                            />
                        </div>
                        <span>{toast.message}</span>
                    </div>
                </div>
            )}

            {/* 메모 삭제 확인 모달 - 사용 안 함 */}
            {/* {deleteMemoModal.open && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100%",
                        maxWidth: "768px",
                        height: "100dvh",
                        backgroundColor: "rgba(0,0,0,0.4)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            width: "85%",
                            maxWidth: "400px",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "20px",
                            padding: "28px 24px 20px",
                            boxShadow: "0 10px 25px rgba(15,23,42,0.2)",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "18px",
                                fontWeight: 600,
                                marginBottom: "12px",
                                color: "#111827",
                            }}
                        >
                            삭제하시겠습니까?
                        </div>
                        <div
                            style={{
                                fontSize: "15px",
                                color: "#6B7280",
                                marginBottom: "24px",
                                lineHeight: 1.5,
                            }}
                        >
                            선택한 메모를 삭제 처리합니다.
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                            }}
                        >
                            <button
                                onClick={() => setDeleteMemoModal({ open: false, memoIndex: null })}
                                style={{
                                    flex: 1,
                                    padding: "10px 20px",
                                    borderRadius: "12px",
                                    border: "none",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    backgroundColor: "#E5E7EB",
                                    color: "#111827",
                                    cursor: "pointer",
                                }}
                            >
                                닫기
                            </button>
                            <button
                                onClick={() => {
                                    if (deleteMemoModal.memoIndex !== null && formData.CompanyCode) {
                                        const updatedMemos = memos.filter((_, idx) => idx !== deleteMemoModal.memoIndex);
                                        setMemos(updatedMemos);
                                        localStorage.setItem(`paymentMemos_${formData.CompanyCode}`, JSON.stringify(updatedMemos));
                                        setDeleteMemoModal({ open: false, memoIndex: null });
                                    }
                                }}
                                style={{
                                    flex: 1,
                                    padding: "10px 20px",
                                    borderRadius: "12px",
                                    border: "none",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    backgroundColor: "#DC2626",
                                    color: "#FFFFFF",
                                    cursor: "pointer",
                                }}
                            >
                                삭제하기
                            </button>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
    );
}

export default AppPaymentUI2;
